import { render } from "./moreTaking.vue?vue&type=template&id=7672a808&scoped=true"
import script from "./moreTaking.vue?vue&type=script&lang=js"
export * from "./moreTaking.vue?vue&type=script&lang=js"

import "./moreTaking.vue?vue&type=style&index=0&id=7672a808&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7672a808"]])

export default __exports__